<template>
  <div>
    <modal-team-create />
    
    <div
      class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
    >
      <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div class="flex flex-wrap items-center">
          <div class="relative w-full max-w-full flex-grow flex-1">
            <h2 class="text-black text-xl text-center font-semibold">Teams</h2>
          </div>
        </div>
      </div>

      <hr class="mt-6 border-b-1 border-gray-400" />

      <FormulateForm>
        <div class="flex flex-wrap mt-6 justify-center">
          <div class="w-full xl:w-6/12 mb-12 xl:mb-0 px-2">
            <span
              class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3"
            >
              <i class="fas fa-search"></i>
            </span>
            <FormulateInput
              type="text"
              placeholder="Search Team Name"
              input-class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring w-full pl-10"
              label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
              help-class="text-xs mb-1 text-gray-600"
              error-class="text-red-700 text-xs mb-1"
              v-model="search"
            />
          </div>
        </div>
      </FormulateForm>

      <hr class="mt-6 border-b-1 border-gray-400" />

      <div class="flex flex-wrap mt-5">
        <div
          class="w-full px-4 text-center"
          v-if="filteredTeams.length == 0 && !this.isLoading"
        >
          <div class="px-4 py-5 flex-auto">
            <h6 class="text-xl font-semibold">No teams available.</h6>
          </div>
        </div>
        <div
          class="w-full md:w-4/12 px-4 text-center"
          v-for="team in filteredTeams"
          :key="team"
        >
          <router-link :to="{ path: '/admin/teams/' + team.id }" @click="navigate">
            <div
              class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
            >
              <div class="px-4 py-5 flex-auto">
                <div
                  class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full"
                >
                  <img
                    class="shadow-xl rounded-full h-auto align-middle border-none absolute"
                    alt="Team"
                    :src="team.image"
                    width="75"
                    height="75"
                  />
                </div>
                <h6 class="text-xl font-semibold">{{ team.name }}</h6>
                <p class="mt-2 mb-4 text-gray-600 font-semibold">
                  {{ team.owner[0].first_name + " " + team.owner[0].last_name }}
                </p>
                <p class="mt-2 mb-4 text-gray-600">
                  {{ team.description }}
                </p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div>
        <button
          @click="createTeam"
          class="w-full md:w-12/12 text-centeruppercase bg-blue-500 hover:bg-blue-700 text-white w-full font-bold py-2 px-4"
        >
          Create new Team
        </button>
      </div>
    </div>
  </div>
</template>
<script>
/* 
  Class: CardTeams
  Description: This class representing a cards with teams.
*/

/* Imports */
import ModalTeamCreate from "@/components/Modals/Teams/ModalTeamCreate.vue";
/* /Imports/ */

export default {
  /* 
    Define data with custom teams state values. 
  */
  data() {
    return {
      teams: [],
      search: "",
      isLoading: true,
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    ModalTeamCreate,
  },

  /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      Show modal for create new team.
    */
    createTeam() {
      this.$modal.show("team-create");
    },

    /* 
      We got all teams and save them to state. 
    */
    getTeams() {
      this.$loading(true);
      
      this.$store.dispatch("teams/getAllTeams").then(() => {
        this.teams = this.$store.state.teams.teamData;
        this.isLoading = false;
        this.$loading(false);
      });
    }
  },

  /* 
    Define computed properties to obtain different getters and setters and save them into the instance. 
  */
  computed: {
    /* 
      Filter all teams for search bar option. 
    */
    filteredTeams() {
      return this.teams.filter((team) =>
        team.name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },

  /* 
    Load all teams after the instance. 
  */
  mounted() {
    this.getTeams();
  }
};
</script>
